import { notify } from "@kyvg/vue3-notification"
import i18n from '../i18n'
const { t } = i18n.global

export async function handleErrorResponse(response: Response) {
    const body = await response.json()
    notify({
        title: body?.error?.title ?? t('error.default.title'),
        text: body?.message ?? body?.error?.detail ?? t('error.default.detail'),
        type: 'error',
    })
}

export async function handleErrorResponseLegacyMethod(response: any) {
    let errorMessage = t('error.default.detail')

    // Check if we have a normal error message response like:
    // { "code": "invalid", "message" : "Product X niet op voorraad." }
    const errorMsg = response?.message ?? null
    if (errorMsg) {
        errorMessage = errorMsg
    }

    let errors = []
    if (Array.isArray(response.errors)) {
        errors = response.errors
    } else if (typeof response.errors === 'object') {
        // It is an object with the field name as key and error messages as value.
        // We need to convert it to an array of error messages
        for (const key in response.errors) {
            if (Array.isArray(response.errors[key])) {
                errors.push(...response.errors[key])
            } else {
                errors.push(response.errors[key])
            }
        }

    }

    if (errors.length > 0) {
        errorMessage = '<ul>'
        errors.forEach((error: string) => {
            errorMessage += '<li>' + error + '</li>'
        })
        errorMessage += '</ul>'
    }

    notify({
        title: t('error.default.title'),
        text: errorMessage,
        type: 'error',
        duration: 7000,
    })
}